import { Injectable } from '@angular/core';
import { Auth } from 'aws-amplify';
import { from, map, Observable, throwError } from 'rxjs';

export type CognitoMfaChallenge = 'SMS_MFA' | 'SOFTWARE_TOKEN_MFA';

export type CognitoSignInResult = {
  status: 'signedIn' | 'mfaRequired' | 'unsupportedChallenge';
};

const MFA_CHALLENGES: string[] = ['SMS_MFA', 'SOFTWARE_TOKEN_MFA'];

@Injectable({ providedIn: 'root' })
export class CognitoAuthService {
  private user = null;
  private challenge: CognitoMfaChallenge = null;
  signIn$(email: string, password: string): Observable<CognitoSignInResult> {
    return from(Auth.signIn(email, password)).pipe(
      map((user): CognitoSignInResult => {
        this.user = user;
        const challenge: CognitoMfaChallenge | undefined = user?.challengeName;
        if (!challenge) {
          return { status: 'signedIn' };
        }
        if (MFA_CHALLENGES.includes(challenge)) {
          this.challenge = challenge;
          return {
            status: 'mfaRequired',
          };
        }
        return { status: 'unsupportedChallenge' };
      })
    );
  }

  confirmSignIn$(code: string) {
    if (this.user == null || this.challenge == null) {
      return throwError(
        () => new Error('No user present. Need to sign in again.')
      );
    }
    return from(Auth.confirmSignIn(this.user, code, this.challenge)).pipe(
      map((): CognitoSignInResult => ({ status: 'signedIn' }))
    );
  }
}
